import { useState } from 'react';
import { contactData } from '@/mocks/home';

export default function SectionContact() {
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFormError('');

    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get('phone_alt') as string;
    if (honeypot && honeypot.trim() !== '') {
      setFormStatus('success');
      form.reset();
      return;
    }

    try {
      const res = await fetch('https://readdy.ai/api/form/d9li3bkit35ii3jdl8k0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: Record<string, unknown> = {};
      try {
        parsed = JSON.parse(responseText);
      } catch {
        // ignore parse error
      }

      if (res.ok && (parsed as { code?: string }).code === 'OK') {
        setFormStatus('success');
        form.reset();
      } else {
        const msg =
          (parsed as { meta?: { message?: string } }).meta?.message ||
          (parsed as { message?: string }).message ||
          (parsed as { meta?: { detail?: string } }).meta?.detail ||
          responseText ||
          '提交失败，请重试';
        setFormStatus('error');
        setFormError(String(msg));
      }
    } catch {
      setFormStatus('error');
      setFormError('网络错误，请稍后重试');
    }
  };

  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1000px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            {contactData.title}
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            {contactData.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-10">
          <div>
            <div className="bg-background-100 rounded-xl p-6 md:p-8">
              <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-5">
                投稿渠道
              </h3>
              <div className="space-y-4">
                {contactData.channels.map((ch, i) => (
                  <div key={i} className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                      <i className={`${ch.icon} text-accent-600`}></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-500 mb-0.5">{ch.label}</p>
                      <p className="text-sm text-foreground-900 font-medium">{ch.value}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div>
            <form
              data-readdy-form
              id="contact-form"
              onSubmit={handleSubmit}
              className="bg-background-100 rounded-xl p-6 md:p-8"
            >
              <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-5">
                快速投稿
              </h3>

              {formStatus === 'success' && (
                <div className="mb-4 px-4 py-3 bg-primary-50 text-primary-700 rounded-lg text-sm">
                  投稿已提交！我们会在24小时内审核并回复。感谢你的爆料！
                </div>
              )}
              {formStatus === 'error' && (
                <div className="mb-4 px-4 py-3 bg-red-50 text-red-700 rounded-lg text-sm">
                  {formError}
                </div>
              )}

              <div className="space-y-4">
                <div>
                  <input
                    type="text"
                    name="title"
                    placeholder="爆料标题（选填）"
                    className="w-full px-4 py-3 bg-background-50 border border-background-200 rounded-lg text-sm text-foreground-900 placeholder-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                  />
                </div>
                <div>
                  <input
                    type="email"
                    name="email"
                    placeholder="你的邮箱（选填，便于回复）"
                    className="w-full px-4 py-3 bg-background-50 border border-background-200 rounded-lg text-sm text-foreground-900 placeholder-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                  />
                </div>
                <div>
                  <textarea
                    name="content"
                    placeholder="爆料内容（必填，请详细描述）"
                    rows={4}
                    maxLength={500}
                    required
                    className="w-full px-4 py-3 bg-background-50 border border-background-200 rounded-lg text-sm text-foreground-900 placeholder-foreground-400 focus:outline-none focus:border-primary-400 transition-colors resize-none"
                  ></textarea>
                  <p className="text-xs text-foreground-500 mt-1">最多500字</p>
                </div>
                <div className="honeypot-field">
                  <input
                    type="text"
                    name="phone_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                  />
                </div>
                <button
                  type="submit"
                  className="w-full py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-lg text-sm transition-colors cursor-pointer whitespace-nowrap"
                >
                  提交爆料
                </button>
                <p className="text-xs text-foreground-500 text-center">
                  我们承诺严格保护你的隐私，绝不泄露投稿人信息
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}